export default "__VITE_ASSET__CFtgyaHF__"